import React, { useEffect, useState } from "react";
import axios from "axios";
import colors from "../Constant/colors";

function GiveSalary() {
  const [teachers, setTeachers] = useState([]);
  const [selectedTeacher, setSelectedTeacher] = useState("");
  const [salaryMonth, setSalaryMonth] = useState("");
  const [baseSalary, setBaseSalary] = useState(""); 
  const [allowances, setAllowances] = useState("");
  const [deductions, setDeductions] = useState("");
  const [netSalary, setNetSalary] = useState("");
  const [remarks, setRemarks] = useState("");
  const [ledger, setLedger] = useState([]);
const [staffType, setStaffType] = useState(""); // "" | "teacher" | "non-teacher"

  const sessionId = localStorage.getItem("currentSessionId");

  // Fetch all teachers for current session
useEffect(() => {
  if (!sessionId || !staffType) return;

  const url =
    staffType === "teacher"
      ? ` ${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeachers?sessionId=${sessionId}`
      : ` ${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getAllNonTeachingStaff?sessionId=${sessionId}`;

  axios
    .get(url)
    .then((res) => setTeachers(res.data))
    .catch((err) => console.error("Error fetching staff:", err));
}, [sessionId, staffType]);


  // Auto-fill teacher info & ledger when teacher is selected
useEffect(() => {
  if (!selectedTeacher || !staffType) {
    setBaseSalary("");
    setAllowances("");
    setDeductions("");
    setRemarks("");
    setLedger([]);
    setNetSalary("");
    return;
  }

  // 1️⃣ Fetch staff master data
  const staffInfoUrl =
    staffType === "teacher"
      ? ` ${process.env.REACT_APP_API_BASE_URL}/api/teachers/getTeacherById/${selectedTeacher}`
      : ` ${process.env.REACT_APP_API_BASE_URL}/api/nonTeachingStaff/getNonTeachingStaffById/${selectedTeacher}`;

  axios
    .get(staffInfoUrl, { params: { sessionId } })
    .then((res) => {
      setBaseSalary(res.data.baseSalary?.toString() || "");
      setAllowances(res.data.allowances?.toString() || "");
      setDeductions("");
      setRemarks("");
    })
    .catch((err) => console.error("Staff info error:", err));

  // 2️⃣ Fetch SAME salary ledger
  axios
    .get(
      ` ${process.env.REACT_APP_API_BASE_URL}/api/staffSalary/ledger/${selectedTeacher}`,
      { params: { sessionId } }
    )
    .then((res) => setLedger(res.data))
    .catch((err) => console.error("Ledger error:", err));

}, [selectedTeacher, staffType, sessionId]);



  // Auto-calculate net salary
  useEffect(() => {
    const net =
      parseFloat(baseSalary || 0) +
      parseFloat(allowances || 0) -
      parseFloat(deductions || 0);
    setNetSalary(net >= 0 ? net.toString() : "0");
  }, [baseSalary, allowances, deductions]);

  // Handle input changes
  const handleChange = (e) => {
    const { name, value } = e.target;

    switch (name) {
      case "salaryMonth":
        setSalaryMonth(value);
        break;
      case "deductions":
        if (/^\d*\.?\d*$/.test(value)) setDeductions(value);
        break;
      case "remarks":
        setRemarks(value);
        break;
      default:
        break;
    }
  };

  // Submit salary
  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!selectedTeacher || !salaryMonth) {
      alert("Please fill all required fields");
      return;
    }

    // Check if salary already paid for selected month
    const alreadyPaid = ledger.some((entry) => entry.salaryMonth === salaryMonth);
    if (alreadyPaid) {
      alert(`Salary for ${salaryMonth} has already been paid.`);
      return;
    }

    const data = {
      teacherId: selectedTeacher,
      sessionId,
      salaryMonth,
      basicSalary: parseFloat(baseSalary) || 0,
      allowances: parseFloat(allowances) || 0,
      deductions: parseFloat(netSalary) || 0,
      netSalary: parseFloat(deductions) || 0,
      remarks,
       staffType 
    };
     if (staffType === "teacher") {
    data.teacherId = selectedTeacher;
  } else {
    data.staffId = selectedTeacher;
  }

    try {
      await axios.post(`${process.env.REACT_APP_API_BASE_URL}/api/teacherSalary/pay`, data,
        {
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` } 
        }
      );
      alert("Salary paid successfully!");

      // Reset monthly inputs
      setSalaryMonth("");
      setDeductions("");
      setRemarks("");

      // Refresh ledger
      const ledgerRes = await axios.get(
        ` ${process.env.REACT_APP_API_BASE_URL}/api/teacherSalary/ledger/${selectedTeacher}`,
        { params: { sessionId: localStorage.getItem("currentSessionId") } }
      );
      setLedger(ledgerRes.data);
    } catch (err) {
  console.error("Error paying salary:", err.response?.data || err.message);
  alert(`Failed to pay salary: ${err.response?.data?.message || err.message}`);
    }
  };

  const buttonStyle = {
    background: colors.gradientPrimary,
    color: "white",
    padding: "12px 22px",
    borderRadius: "8px",
    fontWeight: "700",
    fontSize: "18px",
    border: "none",
    cursor: "pointer",
    boxShadow: "0 4px 12px rgba(0,0,0,0.2)",
  };

  return (
    <div className="w-full p-6 bg-white shadow-xl rounded-xl border border-gray-200">
      <form onSubmit={handleSubmit} className="space-y-5">
        {/* Teacher dropdown */}
        {/* STEP 1: Staff Type */}
<div>
  <label className="block mb-1 font-semibold text-gray-700">Select Staff Type</label>
  <select
    className="w-full border py-2.5 px-3 rounded-lg"
    value={staffType}
    onChange={(e) => {
      setStaffType(e.target.value);
      setSelectedTeacher("");
      setLedger([]);
    }}
  >
    <option value="">-- Select Staff Type --</option>
    <option value="teacher">Teacher</option>
    <option value="non-teaching">Non-Teaching Staff</option>
  </select>
</div>

     {/* STEP 2: Staff selection */}
{staffType && (
  <div>
    <label className="block mb-1 font-semibold text-gray-700">
      Select {staffType === "teacher" ? "Teacher" : "Non-Teaching Staff"}
    </label>

    <select
      className="w-full border py-2.5 px-3 rounded-lg"
      value={selectedTeacher}
      onChange={(e) => setSelectedTeacher(e.target.value)}
    >
      <option value="">-- Select --</option>
      {teachers.map((t) => (
<option key={t._id} value={t._id}>
  {t.firstName && t.lastName
    ? `${t.firstName} ${t.lastName}`
    : t.name}
</option>

      ))}
    </select>
  </div>
)}


        {/* Inputs */}
        <div>
          <label className="block mb-1 font-semibold text-gray-700">Salary Month</label>
          <input
            type="month"
            name="salaryMonth"
            max={new Date().toISOString().slice(0, 7)}
            value={salaryMonth}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-700">Base Salary</label>
          <input
            type="text"
            name="baseSalary"
            value={baseSalary}
            readOnly
            className="w-full border px-3 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 bg-gray-100"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-700">Allowances</label>
          <input
            type="text"
            name="allowances"
            value={allowances}
            readOnly
            className="w-full border px-3 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 bg-gray-100"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-700">Deductions</label>
          <input
            type="text"
            name="deductions"
            value={deductions}
            onChange={handleChange}
            className="w-full border px-3 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-700">Net Salary</label>
          <input
            type="text"
            name="netSalary"
            value={netSalary}
            readOnly
            className="w-full border px-3 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400 bg-gray-100"
          />
        </div>

        <div>
          <label className="block mb-1 font-semibold text-gray-700">Remarks</label>
          <textarea
            name="remarks"
            value={remarks}
            onChange={handleChange}
            placeholder="Optional remarks"
            className="w-full border px-3 py-2 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-400"
          />
        </div>

        <div className="flex justify-start mt-4">
          <button type="submit" style={buttonStyle}>Pay Salary</button>
        </div>
      </form>

      {/* Salary Ledger */}
      {ledger.length > 0 && (
        <div className="mt-8">
<h2 className="text-2xl font-semibold mb-4 text-blue-700">
  Salary History : {teachers.find(t => t._id === selectedTeacher)?.firstName} {teachers.find(t => t._id === selectedTeacher)?.lastName}
</h2>
          <div className="overflow-x-auto">
            <table className="min-w-full border border-gray-300 rounded-lg">
              <thead className="bg-gray-100">
                <tr>
                  <th className="px-4 py-2 border">Month</th>
                  <th className="px-4 py-2 border">Base</th>
                  <th className="px-4 py-2 border">Allowances</th>
                  <th className="px-4 py-2 border">Deductions</th>
                  <th className="px-4 py-2 border">Net Salary</th>
                  <th className="px-4 py-2 border">Remarks</th>
                </tr>
              </thead>
              <tbody>
                {ledger.map((entry) => {
                  const displayRemark = entry.remarks
                    ? entry.remarks
                    : `Salary Paid: ₹${entry.netSalary} for ${entry.salaryMonth}`;
                  return (
                    <tr key={entry._id} className="text-center">
                      <td className="px-4 py-2 border">{entry.salaryMonth}</td>
                      <td className="px-4 py-2 border">{entry.basicSalary}</td>
                      <td className="px-4 py-2 border">{entry.allowances}</td>
                      <td className="px-4 py-2 border">{entry.deductions}</td>
                      <td className="px-4 py-2 border">{entry.netSalary}</td>
                      <td className="px-4 py-2 border">{displayRemark}</td>
                    </tr>
                  );
                })}
              </tbody>
            </table>
          </div>
        </div>
      )}
    </div>
  );
}

export default GiveSalary;
